import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AccountService } from '../services/account.service';
import { map, catchError, of } from 'rxjs';

export const OnboardingGuard: CanMatchFn = () => {
  const accountService = inject(AccountService);
  const router = inject(Router);

  // Existing users clicking an invite email need to reach /onboarding?invite_token=...
  // even though they already have at least one company. Let those through.
  if (typeof window !== 'undefined' && window.location.search.includes('invite_token=')) {
    return of(true);
  }

  return accountService.getUserDetail().pipe(
    map((res: any) => {
      const companies: number[] = res['companies'] || [];
      if (companies.length > 0) {
        router.navigate([companies[0], 'projects']);
        return false;
      }
      return true;
    }),
    catchError(() => of(true)),
  );
};
